var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVolcano(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 104.3 102.1",
    style: {
      enableBackground: "new 0 0 104.3 102.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000062154428203940473910000015659221233546891943_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.3,98.3C91,90.1,64.8,67.8,59.8,23.9c-0.3-1.2-1.4-2.1-2.7-2H56c1,6.3-1.2,8.5-2.4,8.6s-1.5-2.2-1.5-2.2 s0,5.7-2.2,7.1c-1.5,0.9-1.4-4.9-1.2-8.8c-0.1,0.5-0.3,1-0.5,1.6c-1.2,3.6-3.4,2.3-4,0.9s-0.6-7-0.6-7.1c-1.2,0-2.3,0.9-2.4,2.1 C40.2,53.7,25.3,81.3,0.9,98.3c-1.9,1.3-0.7,3.8,1.8,3.8h98.8C104.1,102.1,105.2,99.6,103.3,98.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.8,
    cy: 28.1,
    r: 6.9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 78.8,
    cy: 24.8,
    r: 5.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.8,
    cy: 4.1,
    r: 4.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8,19.2c0,0-11.9-8.9-27.5,8.8l-2-8.2C19.4,19.8,37.9,2.7,48.8,19.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9,15c0,0,1.7-6-9-8.4l1.7-5.4C41.6,1.3,54.8,5.1,48.9,15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5,21.8c0,0,8.5-11.7,18.8,0l6-5.2c0,0-7.2-11.1-16.7-5.9S51.5,21.8,51.5,21.8z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolcano);
export default __webpack_public_path__ + "static/media/volcano.cf2e8da20892dbfc6c998a209bf9404f.svg";
export { ForwardRef as ReactComponent };